import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { XCircle } from "lucide-react";
import { useLang } from "@/context/LanguageContext";

export default function PaymentCancel() {
  const { t } = useLang();
  return (
    <div data-testid="payment-cancel-page" className="min-h-screen bg-[#F8F9FA] flex items-center justify-center px-6">
      <motion.div initial={{ opacity: 0, y: 30 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
        className="relative z-10 max-w-lg w-full text-center bg-white border border-[#0A1128]/10 shadow-lg p-10 md:p-14">
        <XCircle className="mx-auto text-[#1D3557]" size={52} />
        <h1 className="mt-6 font-display text-4xl text-[#0A1128]">{t("pay.cancelled")}</h1>
        <p className="mt-4 text-[#4B5563] leading-relaxed">{t("pay.cancelledSub")}</p>
        <Link to="/" data-testid="cancel-back-home" className="inline-block mt-8 px-8 py-3 bg-[#0A1128] text-white font-semibold hover:bg-[#1D3557] transition-colors">{t("pay.home")}</Link>
      </motion.div>
    </div>
  );
}
